import { connect } from "react-redux";
import SocialSphereSelector from "../components/SocialSphereSelector";
import { fetchGroups, sendAlert, toggleGroupVisibility } from "../actions";
var mapStateToProps = function(state, _ownProps) {
    return {
        users: state.session ? state.users.filter(function(u) {
            var _state_session;
            return u.id !== ((_state_session = state.session) === null || _state_session === void 0 ? void 0 : _state_session.id);
        }) : [],
        session: state.session,
        socialConfig: state.socialConfig,
        groups: state.groups.groups,
        isLoadingGroups: state.loading.indexOf("fetch_groups") > -1
    };
};
var mapDispatchToProps = function(dispatch, _ownProps) {
    return {
        fetchGroups: function() {
            dispatch(fetchGroups());
        },
        sendAlert: function(message, messageType, timeout) {
            dispatch(sendAlert({
                message: message,
                messageType: messageType,
                timeout: timeout
            }));
        },
        toggleGroupVisibility: function(group) {
            dispatch(toggleGroupVisibility({
                group: group
            }));
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(SocialSphereSelector);
